enum PlacesWithCustomHolidays {
	"Le Mans Université",
}

export type CustomHolidays = keyof typeof PlacesWithCustomHolidays;